module.exports = __webpack_public_path__ + "static/media/ic_close.14e60279.svg";